// Transport for the popup OAuth result (/status/ page -> connect app tab).
// window.opener is the primary path. On Android the Instagram app intercepts the OAuth URL and
// re-opens it in a fresh browser tab, so window.opener is null there; BroadcastChannel (same origin)
// is the fallback. Native mobile webviews don't use this file.
const CHANNEL = "phyllo_oauth_result";

export const postOAuthResult = (result) => {
    if (window.opener) {
        window.opener.postMessage(result, process.env.REACT_APP_REDIRECT_URL);
        return true;
    }
    if ("BroadcastChannel" in window) {
        const bc = new BroadcastChannel(CHANNEL);
        bc.postMessage(result);
        bc.close();
        return true;
    }
    return false;
};

// Returns an unsubscribe function. handler receives a MessageEvent from either source.
export const subscribeOAuthResult = (handler) => {
    window.addEventListener("message", handler, false);
    const bc = "BroadcastChannel" in window ? new BroadcastChannel(CHANNEL) : null;
    if (bc) bc.addEventListener("message", handler);
    return () => {
        window.removeEventListener("message", handler, false);
        if (bc) bc.close();
    };
};
